import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companyQuotation = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/orders',

        vehicleTypes: [],
        vehicleTypesLoading: false,
        vehicleTypeLoading: false,

        partCategories: [],
        partCategoryLoading: false,
        partCategoriesLoading: false,

        partTypes: [],
        partTypesLoading: false,
        partTypeLoading: false,

        partBrands: [],
        partBrandsLoading: false,
        partBrandLoading: false,

        measurements: [],
        measurementLoading: false,
        measurementsLoading: false,

        paymentMethods: [],
        paymentMethodLoading: false,
        paymentMethodsLoading: false,

        branches: [],
        branchesLoading: false,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        vehicleTypes: state => state.vehicleTypes,

        partCategories: state => state.partCategories,

        partTypes: state => state.partTypes,

        partBrands: state => state.partBrands,

        measurements: state => state.measurements,

        branches: state => state.branches,
    },
};
